import React from 'react';

import { StateHistory } from 'components/DetailsView';

import { StatusTag } from 'pages/Organizations/components/StatusTag';
import { GetOrganizationQuery } from 'data/__generated__';

export const StatesSection = ({ organization }: { organization: GetOrganizationQuery['organization'] }) => {
    const { state, stateHistory } = organization;
    const formattedStateHistory = stateHistory.map((stateRecord) => ({
        ...stateRecord,
        state: <StatusTag state={stateRecord.state} />,
    }));

    return (
        <>
            <StatusTag state={state} showHeading />
            <StateHistory records={formattedStateHistory} />
        </>
    );
};
